// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2nBvv","alert":"SettungsInbox_alert__2S_Jq"};